import { PROCESSED_NOTIFICATION_KINDS } from 'cpool-constants';
import type { SchemaLoanRequestResolver_GetProcessedNotifications } from 'cpool-tables/backend-resolvers';

import { ProcessedActiveUserSetRow } from './ProcessedActiveUserSetRow';
import { ProcessedAddedAdvisorRow } from './ProcessedAddedAdvisorRow';
import { ProcessedBankReportRow } from './ProcessedBankReportRow';
import { ProcessedDocumentRow } from './ProcessedDocumentRow';
import { ProcessedResubmissionRow } from './ProcessedResubmissionRow';

type Props = {
    entry: SchemaLoanRequestResolver_GetProcessedNotifications[number];
    onNavigate: () => void;
};

export const ProcessedEntryRow: React.FC<Props> = ({ entry, onNavigate }) => {
    if (entry.kind === PROCESSED_NOTIFICATION_KINDS.RESUBMISSION) {
        return (
            <ProcessedResubmissionRow
                loanRequestId={entry.loanRequestId}
                resubmissionAt={entry.resubmissionAt}
                processedAt={entry.processedAt}
                onNavigate={onNavigate}
            />
        );
    }
    if (entry.kind === PROCESSED_NOTIFICATION_KINDS.DOCUMENT) {
        return (
            <ProcessedDocumentRow
                loanRequestId={entry.loanRequestId}
                processedAt={entry.processedAt}
                onNavigate={onNavigate}
            />
        );
    }
    if (entry.kind === PROCESSED_NOTIFICATION_KINDS.ASSIGNED_USER_ADDED) {
        return (
            <ProcessedAddedAdvisorRow
                loanRequestId={entry.loanRequestId}
                processedAt={entry.processedAt}
                onNavigate={onNavigate}
            />
        );
    }
    if (entry.kind === PROCESSED_NOTIFICATION_KINDS.ACTIVE_USER_SET) {
        return (
            <ProcessedActiveUserSetRow
                loanRequestId={entry.loanRequestId}
                processedAt={entry.processedAt}
                onNavigate={onNavigate}
            />
        );
    }
    return (
        <ProcessedBankReportRow
            loanRequestId={entry.loanRequestId}
            subscriptionIdentifier={entry.subscriptionIdentifier}
            processedAt={entry.processedAt}
            onNavigate={onNavigate}
        />
    );
};
